module.exports = __webpack_public_path__ + "img/blogit_screenshot.4ea6e877.jpg";